export default __webpack_public_path__ + "static/media/exterior7.b0bb9c30.jpg";